<template>
  <div class="">
      <!-- Credit Card Settings ... helps signup with Stripe -->

      <br />
      <v-card>

        <v-card-title primary-title>
            <div v-if="acceptInPersonPayment">
              Buyers <b>can</b> choose to pay you in person.
            </div>
            <div v-if="!acceptInPersonPayment">
              Buyers <b>cannot</b> choose to pay you in person.
            </div>
        </v-card-title>

       <v-card-actions>
         <v-spacer></v-spacer>
         <v-btn @click="show = !show" flat color="accent">
            Explain More
           <v-icon class="ml-1">{{show ? $vuetify.icons.up : $vuetify.icons.down}}</v-icon>

         </v-btn>

        </v-card-actions>

        <v-slide-y-transition>
          <v-card-text v-show="show" >
            You can let buyers choose to pay in person when they see you.
            This is good for delivering at school or to friends you see often.
            If a person you don't know or see selects this option you can reject the order
            using the orders screen and ask them to choose to pay by credit card instead.
            <br />

            <v-layout row class="heading success--text " v-show="updateSuccess">
              <v-spacer></v-spacer>
              Change was successful.
              <v-spacer></v-spacer>
            </v-layout>

            <v-layout row class="heading error--text " v-show="errMessage">
              <v-spacer></v-spacer>
              {{errMessage}}
              <v-spacer></v-spacer>
            </v-layout>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="!acceptInPersonPayment" @click="setPaymentInPerson(true)" flat color="accent">
               Allow in person payment
            </v-btn>

            <v-btn v-if="acceptInPersonPayment" @click="setPaymentInPerson(false)" flat color="accent">
               Stop Accepting in person payment
            </v-btn>
          </v-card-actions>

          </v-card-text>
        </v-slide-y-transition>

      </v-card>
</div>

</template>

<script>

import {mapState} from 'vuex'
import firebase from 'firebase/app'

export default {
  name: 'PaymentInPersonSettings',
  components: {
  },
  computed: {
    ...mapState({
      uid: state => state.admin.uid,
      acceptInPersonPayment: state => state.admin.public_settings.acceptInPersonPayment || false,
      acceptCreditCards: state => state.admin.public_settings.acceptCreditCards || false,
      locked: state => state.admin.public_settings.locked

    })
  },
  data () {
    return {
      show: false,
      showStopInPerson: false,
      inprogress: false,
      updateSuccess: false,
      errMessage: null
    }
  },
  methods: {

    setPaymentInPerson: async function (val) {
      // Update the password
      this.inprogress = true
      this.errMessage = null
      this.updateSuccess = false

      if (this.locked) {
        this.errMessage = 'Account is locked. You cannot make any changes.'
        return
      }

      if (val === false && this.acceptCreditCards === false) {
        // Show an error!
        this.errMessage = 'Oops! You need to accept credit cards before you can stop accepting in person payment. Otherwise there will be no way for someone to pay!'
        return
      }
      try {
        // Call the server function to generate a unique CSRF token to validate later
        await firebase.firestore()
          .collection('artists').doc(this.uid).collection('public').doc('settings')
          .set({
            'acceptInPersonPayment': val
          }, {merge: true})

        this.updateSuccess = true
      } catch (err) {
        this.errMessage = err
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
